var _defs, _rect, _rect2, _line, _line2, _line3, _path, _path2, _path3, _path4, _path5, _path6, _line4, _line5, _line6, _line7, _line8, _line9, _line10, _line11, _circle, _circle2, _circle3, _circle4, _circle5, _circle6, _circle7, _circle8, _circle9, _circle10, _circle11, _circle12, _circle13, _circle14, _circle15, _circle16, _circle17, _circle18, _circle19, _text, _text2, _text3, _text4;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgEmptyChartKr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 280 200",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    "aria-hidden": "true",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("radialGradient", {
    id: "kr-bg",
    cx: 84,
    cy: 52,
    r: 200,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#F6F8F7"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#EDF0EF"
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "kro-area",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#32d1c8",
    stopOpacity: 0.16
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#32d1c8",
    stopOpacity: 0.01
  })), /*#__PURE__*/React.createElement("linearGradient", {
    id: "krw-area",
    x1: 0,
    y1: 0,
    x2: 1,
    y2: 0
  }, /*#__PURE__*/React.createElement("stop", {
    offset: "0%",
    stopColor: "#119968",
    stopOpacity: 0.01
  }), /*#__PURE__*/React.createElement("stop", {
    offset: "100%",
    stopColor: "#119968",
    stopOpacity: 0.16
  })), /*#__PURE__*/React.createElement("pattern", {
    id: "kr-grid",
    x: 0,
    y: 0,
    width: 18,
    height: 18,
    patternUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 9,
    cy: 9,
    r: 0.65,
    fill: "#C7D1CC",
    opacity: 0.45
  })))), _rect || (_rect = /*#__PURE__*/React.createElement("rect", {
    width: 280,
    height: 200,
    rx: 14,
    fill: "url(#kr-bg)"
  })), _rect2 || (_rect2 = /*#__PURE__*/React.createElement("rect", {
    x: 40,
    y: 24,
    width: 224,
    height: 150,
    fill: "url(#kr-grid)"
  })), _line || (_line = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 64,
    x2: 264,
    y2: 64,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _line2 || (_line2 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 98,
    x2: 264,
    y2: 98,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _line3 || (_line3 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 134,
    x2: 264,
    y2: 134,
    stroke: "#E0E6E3",
    strokeWidth: 0.75
  })), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M 45 26 C 70 30 116 82 152 95 C 188 108 222 150 260 163 L 260 174 L 45 174 Z",
    fill: "url(#kro-area)"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M 45 163 C 70 159 108 132 152 95 C 196 58 224 36 260 32 L 260 174 L 45 174 Z",
    fill: "url(#krw-area)"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M 45 26 C 70 30 116 82 152 95 C 188 108 222 150 260 163",
    stroke: "#32d1c8",
    strokeWidth: 7,
    strokeOpacity: 0.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    d: "M 45 163 C 70 159 108 132 152 95 C 196 58 224 36 260 32",
    stroke: "#119968",
    strokeWidth: 7,
    strokeOpacity: 0.12,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    d: "M 45 26 C 70 30 116 82 152 95 C 188 108 222 150 260 163",
    stroke: "#32d1c8",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    d: "M 45 163 C 70 159 108 132 152 95 C 196 58 224 36 260 32",
    stroke: "#119968",
    strokeWidth: 1.75,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  })), _line4 || (_line4 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 174,
    x2: 264,
    y2: 174,
    stroke: "#A7B7AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line5 || (_line5 = /*#__PURE__*/React.createElement("line", {
    x1: 40,
    y1: 24,
    x2: 40,
    y2: 174,
    stroke: "#A7B7AF",
    strokeWidth: 1.5,
    strokeLinecap: "round"
  })), _line6 || (_line6 = /*#__PURE__*/React.createElement("line", {
    x1: 96,
    y1: 174,
    x2: 96,
    y2: 179,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line7 || (_line7 = /*#__PURE__*/React.createElement("line", {
    x1: 152,
    y1: 174,
    x2: 152,
    y2: 179,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line8 || (_line8 = /*#__PURE__*/React.createElement("line", {
    x1: 208,
    y1: 174,
    x2: 208,
    y2: 179,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line9 || (_line9 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 64,
    x2: 40,
    y2: 64,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line10 || (_line10 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 98,
    x2: 40,
    y2: 98,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _line11 || (_line11 = /*#__PURE__*/React.createElement("line", {
    x1: 35,
    y1: 134,
    x2: 40,
    y2: 134,
    stroke: "#A7B7AF",
    strokeWidth: 1.25,
    strokeLinecap: "round"
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 26,
    r: 8,
    fill: "#32d1c8",
    fillOpacity: 0.1
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 26,
    r: 3.5,
    fill: "#32d1c8",
    fillOpacity: 0.45
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 45,
    cy: 26,
    r: 2,
    fill: "#32d1c8"
  })), _circle4 || (_circle4 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 57,
    r: 8,
    fill: "#32d1c8",
    fillOpacity: 0.1
  })), _circle5 || (_circle5 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 57,
    r: 3.5,
    fill: "#32d1c8",
    fillOpacity: 0.45
  })), _circle6 || (_circle6 = /*#__PURE__*/React.createElement("circle", {
    cx: 94,
    cy: 57,
    r: 2,
    fill: "#32d1c8"
  })), _circle7 || (_circle7 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 32,
    r: 8,
    fill: "#119968",
    fillOpacity: 0.1
  })), _circle8 || (_circle8 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 32,
    r: 3.5,
    fill: "#119968",
    fillOpacity: 0.45
  })), _circle9 || (_circle9 = /*#__PURE__*/React.createElement("circle", {
    cx: 260,
    cy: 32,
    r: 2,
    fill: "#119968"
  })), _circle10 || (_circle10 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 51,
    r: 8,
    fill: "#119968",
    fillOpacity: 0.1
  })), _circle11 || (_circle11 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 51,
    r: 3.5,
    fill: "#119968",
    fillOpacity: 0.45
  })), _circle12 || (_circle12 = /*#__PURE__*/React.createElement("circle", {
    cx: 209,
    cy: 51,
    r: 2,
    fill: "#119968"
  })), _circle13 || (_circle13 = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 141,
    r: 8,
    fill: "#119968",
    fillOpacity: 0.1
  })), _circle14 || (_circle14 = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 141,
    r: 3.5,
    fill: "#119968",
    fillOpacity: 0.45
  })), _circle15 || (_circle15 = /*#__PURE__*/React.createElement("circle", {
    cx: 91,
    cy: 141,
    r: 2,
    fill: "#119968"
  })), _circle16 || (_circle16 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 95,
    r: 10,
    fill: "none",
    stroke: "#677E72",
    strokeWidth: 0.75,
    strokeOpacity: 0.4,
    strokeDasharray: "3 2"
  })), _circle17 || (_circle17 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 95,
    r: 6,
    fill: "#E0E6E3",
    fillOpacity: 0.6
  })), _circle18 || (_circle18 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 95,
    r: 3.5,
    fill: "#677E72",
    fillOpacity: 0.5
  })), _circle19 || (_circle19 = /*#__PURE__*/React.createElement("circle", {
    cx: 152,
    cy: 95,
    r: 2,
    fill: "#677E72"
  })), _text || (_text = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 21,
    fontSize: 9,
    fontFamily: "system-ui, sans-serif",
    fill: "#32d1c8",
    fillOpacity: 0.85
  }, "Kro")), _text2 || (_text2 = /*#__PURE__*/React.createElement("text", {
    x: 48,
    y: 178,
    fontSize: 9,
    fontFamily: "system-ui, sans-serif",
    fill: "#119968",
    fillOpacity: 0.85
  }, "Krw")), _text3 || (_text3 = /*#__PURE__*/React.createElement("text", {
    x: 152,
    y: 194,
    textAnchor: "middle",
    fontSize: 10,
    fontFamily: "system-ui, sans-serif",
    fill: "#A7B7AF"
  }, "Sw")), _text4 || (_text4 = /*#__PURE__*/React.createElement("text", {
    x: 18,
    y: 99,
    textAnchor: "middle",
    fontSize: 10,
    fontFamily: "system-ui, sans-serif",
    fill: "#A7B7AF",
    transform: "rotate(-90, 18, 99)"
  }, "Kr")));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEmptyChartKr);
export default __webpack_public_path__ + "static/media/empty-chart-kr.09354570ca823f278c3ca43f875302c7.svg";
export { ForwardRef as ReactComponent };